// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__C6tyG","sticky":"NavBar_sticky__-1Ktw","hidden":"NavBar_hidden__OPc3P","item":"NavBar_item__8hG8k","button":"NavBar_button__Nsvh-"};